import React, { useEffect, useState } from 'react'
import { MainTitle } from '../components/MainTitle'
import "../css/WhoAreWe.css"
import * as imagesdata from '../imagesdata'
const WhoAreWe = () => {
  const [fontSize, setFontSize] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const newFontSize = Math.max(15, Math.min(25, (width / 25)));
      setFontSize(newFontSize);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <MainTitle headerImage={imagesdata.HeaderAboutUs} />

      <div className='who-are-we-title-container'>
        <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px` }}>
          <h1>
            <span className='main-title-dark-text-outline'>Biz</span> Kimiz?
          </h1>
        </div>
        <div className='main-text-header text-justify'>
          <h4>
            Traflux olarak, şehir içi trafiğin daha akıllı, güvenli ve verimli hale gelmesini sağlamak amacıyla
            yapay zeka destekli trafik sinyalizasyon sistemleri geliştiren yenilikçi ve teknoloji odaklı bir girişimiz.
            Günümüzün artan trafik sorunlarına karşı modern, sürdürülebilir ve akıllı çözümler sunarak, şehir hayatını
            kolaylaştırmayı ve güvenli hale getirmeyi hedefliyoruz. Kullanıcılarımızın ve şehir yönetimlerinin trafik
            akışını daha etkin bir şekilde düzenlemesine yardımcı olacak ileri seviye teknolojiler geliştirerek,
            ulaşımı daha sistematik ve kontrollü bir hale getirmek için çalışıyoruz.
          </h4>
        </div>

        <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px`, margin:"20px 0 20px 0" }}>
          <h1>
            Vizyonumuz
          </h1>
        </div>
        <div className='main-text-header text-justify'>
          <h4>
            <p>
              Şehirlerin trafik yönetimini yapay zeka ve ileri teknoloji çözümleriyle çok daha akıllı, verimli ve sürdürülebilir
              bir hale getirerek, trafik sıkışıklığını en aza indirmek, yol güvenliğini artırmak, yayaların ve sürücülerin trafik
              deneyimini iyileştirmek ve böylece daha yaşanabilir, konforlu ve çevre dostu kentler oluşturmak.
            </p>
          </h4>
        </div>

        <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px`, margin:"20px 0 20px 0" }}>
          <h1>
            <span className='main-title-dark-text-outline'>Misyonumuz</span>
          </h1>
        </div>
        <div className='main-text-header text-justify'>
          <h4>
            <p>
              Geliştirdiğimiz yapay zeka destekli trafik sinyalizasyon sistemleri ile trafik akışını anlık verilerle en doğru
              şekilde analiz ederek optimize etmeyi, acil durum araçlarının güvenli ve hızlı bir şekilde geçiş yapmasını
              sağlamak için onlara öncelik tanımayı, yayaların güvenliğini artırmak için gerekli durumlarda trafik ışıklarını
              yönlendirmeyi ve trafik yönetimini modernize ederek, herkes için daha güvenli ve akıllı bir ulaşım ağı
              oluşturmayı amaçlıyoruz. Teknolojinin gücünü kullanarak, şehirlerdeki ulaşımı daha düzenli, akıcı ve sürdürülebilir
              hale getirmek temel hedeflerimiz arasındadır.
            </p>
          </h4>
        </div>

        <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px`, margin:"20px 0 20px 0" }}>
          <h1>
            Değerlerimiz
          </h1>
        </div>
        <div className='main-text-header text-justify'>
          <h4>
            <ul style={{ marginLeft: "20px" }}>
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> İnovasyon: </span>
                Sürekli olarak en yeni teknolojileri takip ederek ve geliştirerek, trafik yönetimini daha akıllı, etkili ve
                verimli hale getirmeye yönelik yenilikçi çözümler üretiyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Güvenlik: </span>
                Yol kullanıcılarının, yani hem yayaların hem de sürücülerin güvenliğini en üst seviyeye çıkarmak için
                hassasiyetle çalışıyor, sistemlerimizi bu doğrultuda geliştiriyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Çevre Dostu Yaklaşım: </span>
                Trafik yoğunluğunu azaltarak gereksiz bekleme sürelerini en aza indiriyor, böylece karbon emisyonlarının
                düşmesine katkıda bulunarak çevreye duyarlı çözümler geliştiriyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Şeffaflık: </span>
                Kullanıcılarımıza, iş ortaklarımıza ve şehir yönetimlerine karşı açık, güvenilir ve anlaşılır bir sistem
                sunarak şeffaf bir hizmet sağlıyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Toplumsal Fayda: </span>
                Teknolojiyle şehirleri daha yaşanabilir hale getirirken, toplumun her kesiminin trafik yönetiminden
                eşit şekilde faydalanmasını sağlamaya özen gösteriyoruz.</li>
            </ul>
          </h4>
        </div>

        <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px`, margin:"20px 0 20px 0" }}>
          <h1>
            <span className='main-title-dark-text-outline'>Ne Yapıyoruz?</span>
          </h1>
        </div>
        <div className='main-text-header text-justify'>
          <h4>
            <ul style={{ marginLeft: "20px" }}>
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Yapay Zeka Destekli Araç Sayımı: </span>
                ESP32-CAM donanımı kullanılarak elde edilen görüntülerden faydalanarak, yapay zeka destekli araç tespit
                algoritmaları sayesinde trafik yoğunluğunu doğru ve verimli bir şekilde analiz ediyor, anlık verilerle
                yönetim mekanizmalarına bilgi sağlıyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Dinamik Trafik Işıkları: </span>
                Gerçek zamanlı olarak trafik yoğunluğunu ölçerek, trafik ışıklarının sürelerini dinamik olarak ayarlayan,
                trafiğin daha düzenli ve akıcı hale gelmesini sağlayan akıllı sistemler geliştiriyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Yaya Önceliği: </span>
                Geliştirdiğimiz sensör tabanlı sistemler sayesinde yaya trafiğini aktif bir şekilde takip ederek,
                yayaların güvenli bir şekilde karşıdan karşıya geçmesini sağlamak amacıyla, ihtiyaç duyulduğunda
                araçlara kırmızı ışık uyguluyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Acil Durum Araç Önceliği: </span>
                Polis, itfaiye, ambulans gibi acil müdahale araçlarını özel sensörler ve yapay zeka desteği ile tespit
                ederek, trafik ışıklarını bu araçlara öncelik verecek şekilde optimize ediyor ve acil durum geçişlerini
                hızlandırıyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Web Tabanlı Yönetim ve Gösterim: </span>
                Sistemimizin yönetimini kolaylaştırmak ve trafik verilerini en şeffaf şekilde sunabilmek adına,
                web tabanlı yönetim ve gösterim platformları geliştiriyor, kullanıcıların anlık trafik durumunu
                görüntülemesine ve yönetmesine olanak tanıyoruz.</li> <br />
              <li style={{ listStyle: "outside" }}><span style={{ fontWeight: "500" }}> Entegrasyon Kolaylığı: </span>
                Mevcut trafik altyapıları ve sinyalizasyon sistemleriyle kolayca entegre edilebilecek esneklikte çözümler
                sunarak, şehir yönetimlerinin mevcut sistemlere hızlı ve sorunsuz bir şekilde uyum sağlamasına yardımcı oluyoruz.</li>
            </ul>
          </h4>
        </div>

        <div className='main-text-header text-justify'>
          <h4>
            <p>
              Trafik yönetiminde en ileri yapay zeka ve sensör teknolojilerini kullanarak şehirlerde daha güvenli, düzenli ve
              sürdürülebilir bir ulaşım ağı oluşturma hedefimiz doğrultusunda, sürekli gelişen çözümler üretmeye ve inovatif
              yaklaşımlar geliştirmeye devam ediyoruz.
            </p>
          </h4>
        </div>

      </div>
    </div>
  )
}

export default WhoAreWe